import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';
import AutoSubmit from '@stimulus-components/auto-submit';
import { UltimateTurboModalController } from 'ultimate_turbo_modal';

const application = Application.start();
// Manually load plugins
application.register('auto-submit', AutoSubmit);
application.register('modal', UltimateTurboModalController);
// Automatically load all filed ending with _controllers.js
const controllers = import.meta.glob('./**/*_controller.js', { eager: true });
registerControllers(application, controllers);
